<template>
    <div class="col-12 social-urls">
        <div class="header">
            <h5>
                Social media
            </h5>
            <button
                class="btn btn-success waves-effect waves-light"
                type="button"
                @click="addUrl"
            >
                <i class="fas fa-plus" />
            </button>
        </div>

        <div
            v-for="(url, index) in urls"
            :key="index"
            class="row main-section align-items-center"
        >
            <div class="col-3">
                <div class="form-group">
                    <label :for="`text_${index}`">Text</label>
                    <input
                        :id="`text_${index}`"
                        v-model="url.text"
                        type="text"
                        class="form-control"
                        :class="{
                            'is-invalid': validation.$each[index].text.$error
                        }"
                        dir="auto"
                    />
                    <div class="invalid-feedback">
                        {{ getError('text', index) }}
                    </div>
                </div>
            </div>
            <div class="col-3">
                <div class="form-group">
                    <label :for="`url_${index}`">Url</label>
                    <input
                        :id="`url_${index}`"
                        v-model="url.url"
                        type="text"
                        class="form-control"
                        :class="{
                            'is-invalid': validation.$each[index].url.$error
                        }"
                        dir="auto"
                    />
                    <div class="invalid-feedback">
                        {{ getError('text', index) }}
                    </div>
                </div>
            </div>
            <div class="col-5">
                <label for="icon">Icon</label>
                <media-chooser
                    v-model="url.icon"
                    type="image"
                    :error-border="validation.$each[index].icon.$error"
                />
            </div>
            <div class="col-1 actions-column">
                <button class="action-button" @click="deleteUrl(index)">
                    <i class="far fa-trash-alt" />
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: Array,
            required: true
        },
        validation: {
            type: Object,
            required: true
        },
        serverErrors: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            urls: [...this.value]
        };
    },

    watch: {
        urls: {
            handler(value) {
                this.$emit('input', value);
            },
            deep: true
        }
    },

    methods: {
        addUrl() {
            this.urls = [...this.urls, {}];
        },

        deleteUrl(index) {
            this.urls.splice(index, 1);
        },

        getError(key, index) {
            return this.$getValidationErrorMessageHandler.handle(
                this.validation,
                this.serverErrors,
                key,
                index
            );
        }
    }
};
</script>
